import { wccModules } from 'enums/wccModules';
import { AttachmentsHelpers } from 'helpers/attachments';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import WCCFile from 'models/attachments/file';
import { CustomElementConfig } from '../../../extensions/knockout/bindings/customElement';
import { WCCAttachmentLayoutVMTheme } from '../layouts/base/base.interfaces';
import { IAttachmentLayoutFactory, WCCAttachmentLayout } from '../layouts/iFactory';
import './file.html';
import './file.scss';

export interface WCCFileVMConfig {
    file?: SubscribableOrNullableValue<WCCFile>
    layout?: SubscribableOrNullableValue<WCCAttachmentLayout>
    ratio?: SubscribableOrNullableValue<number>
    theme?: SubscribableOrNullableValue<WCCAttachmentLayoutVMTheme>
}

@injectable()
export default class WCCFileVM {
    layoutConfig: Subscribable<CustomElementConfig>

    constructor(
        @inject(wccModules.componentConfig) configOrFile: WCCFileVMConfig | WCCFile,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.attachmentLayoutFactory) layoutFactory: IAttachmentLayoutFactory
    ) {
        const config = configOrFile instanceof WCCFile ? this.getConfigFromFile(configOrFile) : configOrFile;

        const file = ko.flattenComputed(config.file);
        const ratio = ko.flattenComputed(config.ratio);

        const fileURL = file.pluck(f => f.fileUrl);
        const fileName = file.pluck(f => f.originalFileName);

        const fileExtension = file.pluck(f => f.fileExtension);
        const fileIcon = fileExtension.pluck(ext => AttachmentsHelpers.getFileIcon(ext));

        this.layoutConfig = layoutFactory.create({
            layout: config.layout,

            config: {
                url: fileURL,
                title: fileName,
                icon: fileIcon,
                ratio: ratio,
                theme: config.theme
            }
        });
        
        const isReady = file.isNotNull();

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'wcc-file': true
            }
        });
    }

    private getConfigFromFile(file: WCCFile): WCCFileVMConfig {
        return { file }
    }
}